module.exports = __webpack_public_path__ + "img/DNS-Header.4b7156a.svg";